export interface Volumetry {
  description: string;
  value: number;
  unit: string;
}
export interface VolumetryInput {
  segmentation: Uint8Array;
  spacing: [number, number, number];
  labels: Array<{ index: number; displayName: string }>;
}

export type VolumetryCalculator = (input: VolumetryInput) => Volumetry[];